import { ComponentIds, ValidationResultFail, } from "@inter-ikea-core/core";
import { ValidationBase } from "@inter-ikea-core/core-toolbox";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
import { getEntityProductRef } from "../utils/entityUtils";
export class HeightPlacementRestrictionValidation extends ValidationBase {
    constructor() {
        super(...arguments);
        this.name = "HeightPlacementRestrictionValidation";
        this.id = "HEIGHT_PLACEMENT_RESTRICTION_VALIDATION";
        this.getProductRef = (entity) => {
            var _a;
            return (_a = entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.productRef;
        };
    }
    validateDrawer(entity) {
        var _a, _b;
        const heightRestriction = (_a = entity.getComponent(COMPONENT_IDS.HEIGHT_RESTRICTED_COMPONENT)) === null || _a === void 0 ? void 0 : _a.heightRestriction;
        const drawerHeight = (_b = entity.getComponent(ComponentIds.WORLD_TRANSFORM_COMPONENT_ID)) === null || _b === void 0 ? void 0 : _b.transform.position.Y;
        if (!drawerHeight || !heightRestriction)
            throw new Error("Drawer height or height restriction missing.");
        return drawerHeight <= heightRestriction
            ? null
            : this.getValidationFailMessage(entity);
    }
    validateShelf(entity) {
        var _a;
        const children = (_a = entity.getComponent(ComponentIds.PARENT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.children;
        if (!children)
            return null;
        return children === null || children === void 0 ? void 0 : children.reduce((acc, childEntity) => {
            if (acc !== null)
                return acc;
            if (!childEntity.hasComponent(COMPONENT_IDS.HEIGHT_RESTRICTED_COMPONENT))
                return null;
            return this.validateDrawer(childEntity);
        }, null);
    }
    validateCurrentState(_entity) {
        return null;
    }
    getValidationFailMessage(entity) {
        var _a;
        const productRef = getEntityProductRef(entity);
        const heightRestriction = (_a = entity.getComponent(COMPONENT_IDS.HEIGHT_RESTRICTED_COMPONENT)) === null || _a === void 0 ? void 0 : _a.heightRestriction;
        const message = `product ${productRef} are not allowed above ${heightRestriction}.`;
        return new ValidationResultFail(message, productRef);
    }
    validateSnap(_Snap) {
        const entity = _Snap.guestRoot;
        if (!entity.hasComponent(COMPONENT_IDS.INSERT))
            return null;
        return entity.hasComponent(COMPONENT_IDS.HEIGHT_RESTRICTED_COMPONENT)
            ? this.validateDrawer(entity)
            : this.validateShelf(entity);
    }
}
